import VueI18n from 'vue-i18n'
import en from '../i18n/en'
import es from '../i18n/es'
import Vue from 'vue'

Vue.use(VueI18n)

export default new VueI18n({
    locale: localStorage.getItem('locale') || 'es',
    fallbackLocale: 'es',
    messages: {
        es,
        en
    }
})